import { FilterParams, StoreFilter } from './typings'

type filterMapType = {
  [key: string]: StoreFilter
}

export const ALL_REGIONS_VALUE = 'all'

export const AREA_CODE = 'areaCode'

export const STORE_SIZE = 'storeSize'

export enum StoreSize {
  large = 'LARGE_STORE',
  extraLarge = 'FLAGSHIP_STORE',
  standard = 'STANDARD_STORE',
  small = 'SMALL_STORE',
  none = 'NONE',
}

export enum ProductType {
  baby = 'BABY',
  kids = 'KIDS',
  women = 'WOMEN',
  men = 'MEN',
  maternity = 'MATERNITY',
  teen = 'TEEN',
  uniqloFlower = 'UNIQLO_FLOWER',
  openFrontInner = 'OPEN_FRONT_INNER',
}

export enum StoreService {
  utMe = 'UT_ME',
  reUniqloStudio = 'RE_UNIQLO_STUDIO',
  customOrderMen = 'CUSTOM_ORDER_MEN',
  customOrderWomen = 'CUSTOM_ORDER_WOMEN',
}
export enum Accessibility {
  parking = 'PARKING',
  wheelchairAccessibleParking = 'WHEELCHAIR_ACCESSIBLE_PARKING',
}

export const filterMap: filterMapType = {
  baby: {
    code: ProductType.baby,
    filterParam: FilterParams.storeItem,
    storeFlag: 'baby_flag',
  },
  kids: {
    code: ProductType.kids,
    filterParam: FilterParams.storeItem,
    storeFlag: 'kids_flag',
  },
  women: {
    code: ProductType.women,
    filterParam: FilterParams.storeItem,
    storeFlag: 'women_flg',
  },
  men: {
    code: ProductType.men,
    filterParam: FilterParams.storeItem,
    storeFlag: 'men_flg',
  },
  teen: {
    code: ProductType.teen,
    filterParam: FilterParams.storeItem,
  },
  maternity: {
    code: ProductType.maternity,
    filterParam: FilterParams.storeItem,
    storeFlag: 'maternity_flg',
  },
  openFrontInner: {
    code: ProductType.openFrontInner,
    filterParam: FilterParams.storeItem,
  },
  uniqloFlower: {
    code: ProductType.uniqloFlower,
    filterParam: FilterParams.storeItem,
  },
  normalStore: {
    code: StoreSize.standard,
    filterParam: FilterParams.storeType,
  },
  largeStore: {
    code: StoreSize.large,
    filterParam: FilterParams.storeType,
  },
  extraLargeStore: {
    code: StoreSize.extraLarge,
    filterParam: FilterParams.storeType,
  },
  parking: {
    code: Accessibility.parking,
    filterParam: FilterParams.accessibility,
  },
  wheelchairAccessibleParking: {
    code: Accessibility.wheelchairAccessibleParking,
    filterParam: FilterParams.accessibility,
  },
  utMe: {
    code: StoreService.utMe,
    filterParam: FilterParams.storeService,
  },
  reUniqloStudio: {
    code: StoreService.reUniqloStudio,
    filterParam: FilterParams.storeService,
  },
  customOrderMen: {
    code: StoreService.customOrderMen,
    filterParam: FilterParams.storeService,
  },
  customOrderWomen: {
    code: StoreService.customOrderWomen,
    filterParam: FilterParams.storeService,
  },
}
